"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierService = exports.TermsService = exports.ReviewService = exports.PolicyService = exports.PortalService = exports.PageService = exports.InstanceService = exports.IdentityProviderService = exports.IdentityService = exports.FieldService = exports.ContractService = exports.CategoryService = exports.AssetService = exports.ApplicationOwnerService = exports.ApplicationService = void 0;
var ApplicationService_1 = __importDefault(require("./ApplicationService"));
Object.defineProperty(exports, "ApplicationService", { enumerable: true, get: function () { return ApplicationService_1.default; } });
var AssetService_1 = __importDefault(require("./AssetService"));
Object.defineProperty(exports, "AssetService", { enumerable: true, get: function () { return AssetService_1.default; } });
var CategoryService_1 = __importDefault(require("./CategoryService"));
Object.defineProperty(exports, "CategoryService", { enumerable: true, get: function () { return CategoryService_1.default; } });
var ContractService_1 = __importDefault(require("./ContractService"));
Object.defineProperty(exports, "ContractService", { enumerable: true, get: function () { return ContractService_1.default; } });
var FieldService_1 = __importDefault(require("./FieldService"));
Object.defineProperty(exports, "FieldService", { enumerable: true, get: function () { return FieldService_1.default; } });
var IdentityService_1 = __importDefault(require("./IdentityService"));
Object.defineProperty(exports, "IdentityService", { enumerable: true, get: function () { return IdentityService_1.default; } });
var IdentityProviderService_1 = __importDefault(require("./IdentityProviderService"));
Object.defineProperty(exports, "IdentityProviderService", { enumerable: true, get: function () { return IdentityProviderService_1.default; } });
var InstanceService_1 = __importDefault(require("./InstanceService"));
Object.defineProperty(exports, "InstanceService", { enumerable: true, get: function () { return InstanceService_1.default; } });
var PageService_1 = __importDefault(require("./PageService"));
Object.defineProperty(exports, "PageService", { enumerable: true, get: function () { return PageService_1.default; } });
var PortalService_1 = __importDefault(require("./PortalService"));
Object.defineProperty(exports, "PortalService", { enumerable: true, get: function () { return PortalService_1.default; } });
var PolicyService_1 = __importDefault(require("./PolicyService"));
Object.defineProperty(exports, "PolicyService", { enumerable: true, get: function () { return PolicyService_1.default; } });
var ReviewService_1 = __importDefault(require("./ReviewService"));
Object.defineProperty(exports, "ReviewService", { enumerable: true, get: function () { return ReviewService_1.default; } });
var StatusService_1 = __importDefault(require("./StatusService"));
var TermsService_1 = __importDefault(require("./TermsService"));
Object.defineProperty(exports, "TermsService", { enumerable: true, get: function () { return TermsService_1.default; } });
var TierService_1 = __importDefault(require("./TierService"));
Object.defineProperty(exports, "TierService", { enumerable: true, get: function () { return TierService_1.default; } });
var ApplicationOwnerService_1 = __importDefault(require("./ApplicationOwnerService"));
Object.defineProperty(exports, "ApplicationOwnerService", { enumerable: true, get: function () { return ApplicationOwnerService_1.default; } });
__exportStar(require("./types"), exports);
var buildClient = function (config, logger) {
    return {
        applications: new ApplicationService_1.default(config, logger),
        applicationOwners: new ApplicationOwnerService_1.default(config, logger),
        assets: new AssetService_1.default(config, logger),
        categories: new CategoryService_1.default(config, logger),
        contracts: new ContractService_1.default(config, logger),
        fields: new FieldService_1.default(config, logger),
        identities: new IdentityService_1.default(config, logger),
        identityProviders: new IdentityProviderService_1.default(config, logger),
        instances: new InstanceService_1.default(config, logger),
        pages: new PageService_1.default(config, logger),
        portals: new PortalService_1.default(config, logger),
        policies: new PolicyService_1.default(config, logger),
        reviews: new ReviewService_1.default(config, logger),
        status: new StatusService_1.default(config, logger),
        terms: new TermsService_1.default(config, logger),
        tiers: new TierService_1.default(config, logger)
    };
};
exports.default = buildClient;
